export default {
    modalShowImageVariations: {
        imageAi: 'Image AI',
        regenerateImage: 'Geneer nieuwe content',
        description: 'Omschrijving:',
        style: 'Style:',
        saveToLibrary: 'Save to Library',
        continue: 'Doorgaan',
        cancel: 'Annuleer',
        select: 'Select',
        copy: 'Kopie',
    },
};
